import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-relevance-form/relevance-form.vue";
import mobile from "./components/mobile-relevance-form/relevance-form.vue";
export const info = {
    title: "关联单选",
    type: "relevance-form",
    icon: "h-icon-all-form-related-o",
    dataItemType: DataItemType.RelevanceForm,
    formControllerType: FormControlType.RelevanceForm,
    group: "高级控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile,
    },
};
